import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, info: null }; }
  componentDidCatch(error, info) { this.setState({ error, info }); }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 32, fontFamily: 'monospace', background: '#fff',
          minHeight: '100vh', color: '#1c1c1e',
        }}>
          <div style={{ background: '#FF3B30', color: '#fff', padding: '12px 20px', borderRadius: 10, marginBottom: 20 }}>
            <strong>App crashed — see error below</strong>
          </div>
          <pre style={{
            background: '#f8f8f8', padding: 20, borderRadius: 10,
            whiteSpace: 'pre-wrap', fontSize: 13, color: '#FF3B30',
            border: '1px solid #ffd0d0',
          }}>
            {String(this.state.error)}
            {'\n\n'}
            {this.state.info?.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
